
class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-notification").deleteQuantity(this.dataset.index, 0);
      this.closest(".cart-notification-product").classList.add("loader");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.cartItemConatiner = document.getElementById(
      "cart-notification-product"
    );

    this.emptyCartItem = document.getElementById("min-cart-items");
    this.cartItemMessageShow = document.querySelector(".empty__cart__item");
    this.emptyCartButtonDisable = document.getElementById(
      "empty__cart__button"
    );
    this.topBar = document.querySelector('.cart_notification_topbar');

    this.cartAddSuccess = document.querySelector(".item__success_message ");
    this.cartEmptyHead = document.querySelector(".item__empty_message");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    
    this.upsell();
  }

  onChange(event) {
    if (event.target.classList.contains('docapp-coupon-input--input')) {
      return;
    }
    if (!event.target.closest("select")) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
      );
    }
  }

  open() {
    return;
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
    this.updateTopBar();
  }

  close() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClick);
  }

  renderContents(renderSelector, onlyTop) {
    let onlyTopThis = onlyTop;
    fetch('/?section_id=cart-drawer-ajax').then((response) => {
      return response.text();
    })
      .then(async (state) => {
        window.freeGiftStatus = await window.freeGiftPromo.init();
        if(window.freeGiftStatus){
          this.renderContents();
          return
        }
        var s = state;
        var temp = document.createElement('div');
        temp.innerHTML = s;
        var htmlObject = temp.firstChild;
        try {
          window.cart = JSON.parse(htmlObject.querySelector(".cart-json").innerHTML)
        }
        catch (e) {
          console.log(e);
        }

        if (onlyTopThis) {
          document.querySelector('cart-notification .cart__items').innerHTML = htmlObject.querySelector('cart-notification .cart__items').innerHTML;
        }
        else {
          document.querySelector('cart-notification').innerHTML = htmlObject.querySelector('cart-notification').innerHTML;
        }
        let cartItemCount = htmlObject.querySelector('.cart-notification__heading').getAttribute("data-count");
        cartItemCount = parseInt(cartItemCount);
        document.querySelector("#cart-notification-count").innerText = cartItemCount;
        if (cartItemCount > 0) {
          document.querySelector("#cart-notification-count").style.display = 'flex';
        }
        else {
          document.querySelector("#cart-notification-count").style.display = 'none';
        }
        return;
        this.open();
        this.upsell();
        checkDiscountApplied();
      })
    return;

    this.getSectionsToRender().forEach((section) => {
      let renderSelector = document.getElementById(section.id);
      if (renderSelector) {
        renderSelector.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id]
        );
      }
    });
    let cartItemCount = parsedState.quantity || parsedState.item_count;
    document.querySelector("#cart-notification-count").innerText = cartItemCount;
    document.querySelector('.item__success_message').innerText = `Cart • ${cartItemCount}`;
    document.querySelector('.item__empty_message').innerText = `Cart • ${cartItemCount}`;
    if (cartItemCount == 0) {
      this.topBar.classList.add('flex-grow-1');
      this.emptyCartItem.classList.add("no-js-inline");
      this.emptyCartButtonDisable.classList.add("no-js-inline");
      this.cartItemMessageShow.classList.remove("no-js-inline");
      this.cartAddSuccess.classList.add("no-js-inline");
      this.cartEmptyHead.classList.remove("no-js-inline");
      document.querySelector("#cart-notification-count").style.display = 'none';
    } else {
      document.querySelector("#cart-notification-count").style.display = 'flex';
      this.topBar.classList.remove('flex-grow-1');
      this.emptyCartItem.classList.remove("no-js-inline");
      this.emptyCartButtonDisable.classList.remove("no-js-inline");
      this.cartItemMessageShow.classList.add("no-js-inline");
      this.cartAddSuccess.classList.remove("no-js-inline");
      this.cartEmptyHead.classList.add("no-js-inline");
    }

    if (this.header) this.header.reveal();
    this.open();
    this.upsell();
    updatePrices();
  }
s
  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-subtotal",
      },

      {
        id: "cart-notification-discount"
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let parsedState = JSON.parse(state);
        this.renderContents(parsedState);

        if (parsedState.item_count > 0) {

          this.updateLiveRegions(line, parsedState.item_count);
        }
      })
      .catch(() => {
        console.error(e);
      })
      .finally(() => {
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.remove("active");
        this.updateTopBar();

      });
  }
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        );
      document
        .getElementById(`Line-item-error-${line}`)
        .classList.remove("no-js-inline");
    } else {
      document
        .getElementById(`Line-item-error-${line}`)
        .classList.add("no-js-inline");
    }
    this.currentItemCount = itemCount;
  }

  deleteQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let parsedState = JSON.parse(state);
        this.renderContents(parsedState);
      })
      .catch(() => {
        console.error(e);
      })
      .finally(() => {
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.remove("active");
        this.updateTopBar();
      });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateTopBar() {
    return false;
    var targetElement = document.querySelector("[data-est-total]");

    var targetElement = document.querySelector('[data-code="10PERCENTOFF"]');
    const beanContainer = document.querySelector(".coupon-input--bean-container");
    const inputContainer = document.querySelector(".docapp-coupon-input--input-container");
    const summaryNote = document.querySelector(".summary-cart-item.docapp-summary-note");
    
    if (beanContainer) {
      if (beanContainer.children.length == 0) {
        if (inputContainer) inputContainer.style.display = 'block';
        if (summaryNote) summaryNote.style.display = 'block';
      } else if (beanContainer.children.length == 1) {
        var checkDiscountElement = beanContainer.querySelector(".coupon-input--bean-container--bean-remove");
        if (checkDiscountElement) {
          var discount = checkDiscountElement.getAttribute("data-code");
          if (discount == "10PERCENTOFF") {
            // Show input container and summary note if needed
          } else {
            // Hide input container and summary note if needed
          }
        }
      } else {
        // Hide input container and summary note
      }
    }

    // Load cart notification heading
    const headingEl = document.querySelector(".cart-notification__heading");
    if (headingEl) {
      fetch(location.href)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newHeading = doc.querySelector(".cart-notification__heading");
          if (newHeading) {
            headingEl.innerHTML = newHeading.innerHTML;
          }
        })
        .catch(err => console.error('Error loading heading:', err));
    }
    
    if (targetElement == null) {
      // Below 2 lines are for custom code for 25% section on top
      const discountSection = document.querySelector(".discountshow-section");
      if (discountSection) {
        fetch(location.href)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newSection = doc.querySelector(".discountshow-section");
            if (newSection) {
              discountSection.innerHTML = newSection.innerHTML;
            }
          })
          .catch(err => console.error('Error loading discount section:', err));
      }
    } else {
      const appliedDiscount = document.querySelector(".applied-discount");
      const notAppliedDiscount = document.querySelector('.not-applied-discount');
      if (appliedDiscount) appliedDiscount.style.display = 'block';
      if (notAppliedDiscount) notAppliedDiscount.style.display = 'none';
    }
  }

  upsell() {
    let thisparent = this;
    let upsellAddToCartButtons = document.querySelectorAll('.upsell_add_to_cart-button');
    upsellAddToCartButtons.forEach((i) => {
      i.addEventListener('click', (e) => {
        e.preventDefault();
        e.currentTarget.value = 'Adding...';
        i.classList.add('adding');
        let addToCartForm = i.closest('form[data-type="add-to-cart-form"]');
        let formData = new FormData(addToCartForm);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
          .then((response) => response.json())
          .then((parsedState) => {
            document.querySelector('cart-notification').renderContents(parsedState);
            return;
            if (parsedState.status) {
              thisparent.handleErrorMessage(parsedState.description);
              return;
            }

            //   document.querySelector('cart-notification').renderContents(parsedState);
            fetch(window.Shopify.routes.root)
              .then((response) => {
                return response.text();
              })
              .then((html) => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                let newProductContent = doc.querySelector('#cart-notification').innerHTML;
                document.querySelector('#cart-notification').innerHTML = newProductContent;
                let count = doc.querySelector('#cart-notification-count').innerHTML;
                document.querySelector('#cart-notification-count').innerHTML = count;
                document.querySelector('cart-notification').upsell()
                updatePrices();

              })
              .catch(() => {
                console.error(e);
              })
          })
          .catch((error) => {
            console.error('Error:', error);
          });

      })
    })

    let upsellSelects = document.querySelectorAll('.pd-recommend-select');
    upsellSelects.forEach(function (i) {
      i.addEventListener('change', function (e) {
        let upsellSelectValue = i.value;
        let upsellPrice = i.options[i.selectedIndex].getAttribute('data-price');
        let upsellComparePrice = i.options[i.selectedIndex].getAttribute('data-cprice');
        i.closest('form').querySelector('[name="id"]').value = upsellSelectValue;
        if (upsellComparePrice != null) {
          i.closest('.Stack').querySelector('.upcart-upsell-item-price-row').innerHTML = `<span class="upcart-upsell-item-price UpcartDesignSettings__cartTextColor upcart-default-price">${upsellComparePrice}</span> <span class="upcart-upsell-item-price UpcartDesignSettings__cartTextColor upcart-discount-price">${upsellPrice}</span>`;
        } else {
          i.closest('.Stack').querySelector('.upcart-upsell-item-price-row').innerHTML = `<span class="upcart-upsell-item-price UpcartDesignSettings__cartTextColor upcart-discount-price">${upsellPrice}</span>`;
        }
      })
    })
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.cartButton = this.querySelector('a');

    this.cartButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.miniCartClose()
    );
  }

  onClickMiniCart() {
    return;
    document
      .getElementById("offcanvas__mini_cart")
      .classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
  }

  miniCartClose() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClassRemove);
    removeTrapFocus(document.querySelector(".header__actions_btn--cart"));
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    //console.log(eventTarget);
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }


}
customElements.define("open-minicart", OpenMiniCart);

window.customDiscountApply = (discountCode) => {
  const cartToken = getCookieValue('cart');
  if (!cartToken) {
    console.log("cart token not found");
    return;
  }

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("X-Shopify-Storefront-Access-Token", "2a3b4f7e898ea506e22c72ab19ff89d2")
  let graphql = JSON.stringify({
    query: `mutation cartDiscountCodesUpdate($cartId: ID!) {
  cartDiscountCodesUpdate(cartId: $cartId,discountCodes:"${discountCode}") {
    
    cart {
      discountCodes{
        code
        applicable
      }
    }
    userErrors {
      field
      message
    }
  }
}`,
    variables: { "cartId": `gid://shopify/Cart/${window.cartToken}` }
  });
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow"
  };

  fetch("https://whats-up-wellness.myshopify.com/api/2021-07/graphql.json", requestOptions)
    .then((response) => response.text())
    .then((result) => {
      let resultJson = JSON.parse(result);
      let availableCodeChecker = resultJson.data.cartDiscountCodesUpdate.cart.discountCodes[0].applicable;
      if (!availableCodeChecker && discountCode) {
        discountCode = discountCode.toUpperCase();
        document.querySelector('.docapp-coupon-input--error-message-content').innerHTML = `Coupon code '${discountCode}' could not be applied`;
        document.querySelector('.discount-code-clip').innerText = discountCode;
        document.querySelector('.coupon-input--error-message-container').classList.remove('docapp-hide');
        showDiscountBox();
        return
      }
      if (discountCode == '') {
        showDiscountBox();
      } else {
        showAppliedDiscount(discountCode);
      }
      document.querySelector('cart-notification').renderContents("", 'only-top');
      updatePrices();

    })
    .catch((error) => console.error(error))
    .finally((e) => {

      document.querySelector('.docapp-coupon-input--button').classList.remove("btn-loading");
    })
}
window.getCartToken = async () => {
  let cart = await fetch('/cart.json');
  cart = await cart.json();
  window.cartToken = cart.token;
}
getCartToken();
window.checkDiscountApplied = async function () {
  let cart =  await fetch('/cart.json');
  cart = await cart.json();
  let appliedDiscountCode = cart.items.find(item => {
    return item.discounts.length
  })
  if (appliedDiscountCode) {
    appliedDiscountCode = appliedDiscountCode.discounts[0].title;
  }
  if (!appliedDiscountCode) {

    showDiscountBox();
  } else {
    showAppliedDiscount(appliedDiscountCode);
  }
  updatePrices(cart);
  if (!appliedDiscountCode) {
    document.querySelector('#cart-other-details').innerHTML = '';
  }
}
checkDiscountApplied();
function showDiscountBox() {
  /* Show discount box and hide applied discount */
  if(document.querySelector('#custom-discount-msg')){
    if (document.querySelector('#custom-discount-msg').checked) {
      document.querySelector('#custom-discount-msg').checked = !document.querySelector('#custom-discount-msg').checked;
    }
  }
  if(document.querySelector('.docapp-summary-note')){
    document.querySelector('.docapp-summary-note').style.display = 'flex';
  }
  if(document.querySelector('.coupon-input--input-container')){
    document.querySelector('.coupon-input--input-container').style.display = 'flex';
  }
  document.querySelector('.coupon-input--bean-container')?.classList.add('docapp-hide');
  document.querySelector('.docapp-coupon-input--message-container').classList.add('docapp-hide');
  document.querySelector('.docapp-coupon-input--message-container').classList.remove('docapp-alert-success');
}
function showAppliedDiscount(appliedDiscountCode) {
  appliedDiscountCode = appliedDiscountCode.toUpperCase();
  /* Show applied discount and hide discount box */
  if(document.querySelector('.docapp-summary-note')){
    document.querySelector('.docapp-summary-note').style.display = 'none';
  }
  if(document.querySelector('.coupon-input--input-container')){
    document.querySelector('.coupon-input--input-container').style.display = 'none';
  }
  document.querySelector('.docapp-coupon-input--message-container').classList.remove('docapp-hide');
  document.querySelector('.coupon-input--bean-container')?.classList.remove('docapp-hide');
  if(document.querySelector('.docapp-coupon-input--message-container .docapp-coupon-input--message-content')){
    document.querySelector('.docapp-coupon-input--message-container .docapp-coupon-input--message-content').innerText = `Coupon code '${appliedDiscountCode}' applied`;
  }
  if(document.querySelector('.discount-code-clip')){
    document.querySelector('.discount-code-clip').innerText = appliedDiscountCode;
  }
  if(document.querySelector('.docapp-coupon-input--message-container')){
    document.querySelector('.docapp-coupon-input--message-container').classList.add('docapp-alert-success');
  }
}

async function updatePrices(cart) {
  let newCartPrice;
  if(cart){
    newCartPrice = cart;
  }
  else{
    newCartPrice = await fetch('/cart.json');
    newCartPrice = await newCartPrice.json()
  }
  
  /* add code for subtotal and discount part */
  let cartTotal = newCartPrice.total_price;
  let cartOriginalTotal = newCartPrice.original_total_price;
  let cartDiscountAmount = newCartPrice.total_discount;

  cartTotalAmount = `Rs. ${(cartOriginalTotal / 100.00).toFixed(2)}`;
  document.querySelector('#cart-notification-subtotal').innerHTML = cartTotalAmount;
  if (cartOriginalTotal > cartTotal) {
    let discountPercent = Math.floor((cartDiscountAmount / cartOriginalTotal) * 100.00);
    let cartActualDiscountAmount = `Rs. ${(cartDiscountAmount / 100.00).toFixed(2)}`;
    document.querySelector('#cart-other-details').innerHTML = `
   <div class="discount-details">
   <span class="left-discount">Discount </span>
   <span class="discount-amount">${cartActualDiscountAmount}</span>
   </div>
    <div class="total-details">
   <span class="total-left">Total</span>
   <span class="total-right-amount"><span class="strike">Rs. ${(cartOriginalTotal / 100).toFixed(2)}</span>  <span>Rs. ${(cartTotal / 100).toFixed(2)}</span></span>
   </div>`;
  }
}
document.addEventListener("click", e => {
  /* Apply button click event */
  if (!e.target.classList.contains("coupon-button-text") && !e.target.closest('.coupon-button-text')) {
    return
  }

  document.querySelector('.docapp-coupon-input--button').classList.add("btn-loading");
  document.querySelector('.coupon-input--error-message-container').classList.add('docapp-hide');
  const discountCode = document.querySelector(".docapp-coupon-input--input").value;
  customDiscountApply(discountCode)
})
document.addEventListener("click", e => {
  /* Remove button of discount badge */
  if (!e.target.classList.contains("coupon-input--bean-container--bean-remove")) {
    return
  }
  document.querySelector(".docapp-coupon-input--input").value = "";
  customDiscountApply('');
  showDiscountBox();
  document.querySelector('#cart-other-details').innerHTML = '';
})
document.addEventListener("click", e => {
  /* Apply button click event */
  if (!e.target.classList.contains("docapp-coupon-input--message-x")) {
    return
  }
  let parentElement = e.target.parentElement;
  parentElement.classList.add('docapp-hide');
})

document.addEventListener("click", (e) => {
  if (e.target.classList.contains('cart-notification__close') || e.target.closest('.cart-notification__close')) {
    document.querySelector('cart-notification').close();
    return;
  }
  if (!e.target.classList.contains("auto-apply-special-discount") && !e.target.closest('.auto-apply-special-discount')) {
    return false;
  }
  let discountCode = document.querySelector('.auto-apply-special-discount').dataset.code;
  if (!discountCode) {
    return;
  }
  document.querySelector(".docapp-coupon-input--input").value = discountCode;
  document.querySelector(".coupon-button-text").click();
})
